import { FeesURL } from '@tcs/client-portal-api/platform_generated';
import { useQuery } from '@tcs/common/hooks/useQuery';

// retrieve the Wells Fargo SSO link
export const useFeesLink = (accountNumber) => {
  const { data: feesResponse, isLoading: loading } = useQuery<FeesURL, Error>(
    `/accounts/${accountNumber}/FeesURL`,
    {
      refetchOnMount: false,
    }
  );

  return {
    loading: loading,
    data: feesResponse,
  };
};

export default useFeesLink;
